export default __webpack_public_path__ + "static/media/Flag_of_Marshall_Islands.2d8fbc15.svg";